import { render, staticRenderFns } from "./SocialLead.vue?vue&type=template&id=a839cdaa&scoped=true"
import script from "./SocialLead.vue?vue&type=script&lang=js"
export * from "./SocialLead.vue?vue&type=script&lang=js"
import style0 from "./SocialLead.vue?vue&type=style&index=0&id=a839cdaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a839cdaa",
  null
  
)

export default component.exports